import React from "react";

export default function EngagementLineChart({
  points = [],
  color = "#76B3FF",
  emptyText = "Noch keine Daten vorhanden.",
}) {
  const hasPoints = Array.isArray(points) && points.length > 0;
  const hasUsage = hasPoints && points.some((point) => (point.answeredCount || 0) > 0);

  if (!hasPoints || !hasUsage) {
    return (
      <div className="rounded-2xl border border-dashed border-black/10 bg-white px-4 py-8 text-center text-sm text-gray-600">
        {emptyText}
      </div>
    );
  }

  const width = 640;
  const height = 240;
  const paddingX = 48;
  const paddingTop = 24;
  const paddingBottom = 54;
  const chartHeight = height - paddingTop - paddingBottom;
  const chartWidth = width - paddingX * 2;
  const maxValue = Math.max(...points.map((point) => point.answeredCount || 0), 1);

  const coordinates = points.map((point, index) => {
    const x =
      points.length === 1
        ? width / 2
        : paddingX + (index * chartWidth) / (points.length - 1);
    const y =
      height -
      paddingBottom -
      ((point.answeredCount || 0) / maxValue) * chartHeight;

    return {
      ...point,
      x,
      y,
    };
  });

  const polyline = coordinates.map((point) => `${point.x},${point.y}`).join(" ");
  const gridValues = [0, 0.5, 1];

  return (
    <div className="w-full overflow-x-auto">
      <svg
        viewBox={`0 0 ${width} ${height}`}
        className="h-[240px] w-full min-w-[520px]"
        role="img"
        aria-label="Entwicklung der beantworteten Fragen"
      >
        {gridValues.map((value) => {
          const y = height - paddingBottom - value * chartHeight;
          const label = Math.round(value * maxValue);

          return (
            <g key={value}>
              <line
                x1={paddingX}
                x2={width - paddingX}
                y1={y}
                y2={y}
                stroke="#E5E7EB"
                strokeWidth="1"
              />
              <text
                x={paddingX - 10}
                y={y + 4}
                textAnchor="end"
                fontSize="11"
                fill="#6B7280"
              >
                {label}
              </text>
            </g>
          );
        })}

        <polyline
          fill="none"
          stroke={color}
          strokeWidth="3"
          strokeLinejoin="round"
          strokeLinecap="round"
          points={polyline}
        />

        {coordinates.map((point) => (
          <g key={point.roundId || point.occurrenceId || point.label}>
            <circle
              cx={point.x}
              cy={point.y}
              r="5"
              fill={color}
            />
            <text
              x={point.x}
              y={point.y - 12}
              textAnchor="middle"
              fontSize="11"
              fill="#111827"
            >
              {point.answeredCount || 0}
            </text>
            <text
              x={point.x}
              y={height - 20}
              textAnchor="middle"
              fontSize="11"
              fill="#6B7280"
            >
              {String(point.label || "").slice(0, 12)}
            </text>
          </g>
        ))}
      </svg>
    </div>
  );
}
